<template lang="html">
  <div class="d-flex fill-height" style="flex-direction: column">
    <div class="d-flex" style="flex: 1 1 auto">
      <div class="ma-auto text-center">
        <img :src="require('@/assets/img/png/store_not_found.png')" height="280" class="mb-6" />
        <div class="mb-2 font-weight-bold" style="font-size: 24px">Toko tidak ditemukan</div>
        <div>Pastikan link toko sudah benar</div>
      </div>
    </div>
    <div class="d-flex pa-6">
      <div class="ma-auto text-center">
        <div>Powered by</div>
        <img src="@/assets/img/png/olsera_logo.png" alt="Olsera" height="34" />
      </div>
    </div>
  </div>
</template>
<script>
export default {}
</script>
